

/// <reference path="CoreEntityUpdatedBy.ts" />

// Generated class AccountingJournalTemplate_ManagedObject

class AccountingJournalTemplate_ManagedObject extends CoreEntityUpdatedBy
{

    // Property: beginFrom
    set beginFrom(value:Date) {
        this.setValueForKey(value, 'beginFrom');
    }
    get beginFrom():Date {
        return this.valueForKey('beginFrom');
    }
    set beginFromPrimitiveValue(value:Date) {
        this.setPrimitiveValueForKey(value, 'beginFrom');
    }
    get beginFromPrimitiveValue():Date {
        return this.primitiveValueForKey('beginFrom');
    }

    // Property: endTo
    set endTo(value:Date) {
        this.setValueForKey(value, 'endTo');
    }
    get endTo():Date {
        return this.valueForKey('endTo');
    }
    set endToPrimitiveValue(value:Date) {
        this.setPrimitiveValueForKey(value, 'endTo');
    }
    get endToPrimitiveValue():Date {
        return this.primitiveValueForKey('endTo');
    }

    // Property: eventType
    set eventType(value:number) {
        this.setValueForKey(value, 'eventType');
    }
    get eventType():number {
        return this.valueForKey('eventType');
    }
    set eventTypePrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'eventType');
    }
    get eventTypePrimitiveValue():number {
        return this.primitiveValueForKey('eventType');
    }

    // Property: isActive
    set isActive(value:boolean) {
        this.setValueForKey(value, 'isActive');
    }
    get isActive():boolean {
        return this.valueForKey('isActive');
    }
    set isActivePrimitiveValue(value:boolean) {
        this.setPrimitiveValueForKey(value, 'isActive');
    }
    get isActivePrimitiveValue():boolean {
        return this.primitiveValueForKey('isActive');
    }
    // Relationship: analyticAccount
    set analyticAccount(value:AnalyticAccount) {
        this.setValueForKey(value, 'analyticAccount');
    }
    get analyticAccount():AnalyticAccount {
        return this.valueForKey('analyticAccount') as AnalyticAccount;
    }

    // Relationship: lines
    protected _lines:MIOManagedObjectSet = null;
    get lines():MIOManagedObjectSet {
        return this.valueForKey('lines');
    }
    addLinesObject(value:AccountingJournalLineTemplate) {
        this._addObjectForKey(value, 'lines');
    }
    removeLinesObject(value:AccountingJournalLineTemplate) {
        this._removeObjectForKey(value, 'lines');
    }
}
